export enum IEniatoHomeSectionEnum {
    INTRODUCTION = 'introduction',
    CARD_CONTENT = 'cards-content',
    CATEGORIES = 'categories',
    CARDS = 'cards',
    CAROUSEL_BANNERS = 'carousel-banners',
    TOP_COLLECTIONS = 'top-collections',
    TOKENS_LIST = 'tokens-list'
}